import { render, staticRenderFns } from "./files2.vue?vue&type=template&id=a72935e2&scoped=true&"
import script from "./files2.vue?vue&type=script&lang=js&"
export * from "./files2.vue?vue&type=script&lang=js&"
import style0 from "./files2.vue?vue&type=style&index=0&id=a72935e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72935e2",
  null
  
)

export default component.exports